<template>
  <div class="idioma" ref="raiz">
    <button
      type="button"
      class="idioma-botao"
      :aria-label="rotulo"
      :aria-expanded="aberto"
      aria-haspopup="listbox"
      @click="aberto = !aberto"
    >
      <Bandeira :codigo="escolhido" />
      <span class="idioma-sigla">{{ escolhido.toUpperCase() }}</span>
    </button>
    <ul v-if="aberto" class="idioma-lista" role="listbox" :aria-label="rotulo">
      <li v-for="item in IDIOMAS" :key="item.codigo">
        <button
          type="button"
          role="option"
          :aria-selected="item.codigo === escolhido"
          class="idioma-opcao"
          :class="{ ativo: item.codigo === escolhido }"
          @click="escolher(item.codigo)"
        >
          <Bandeira :codigo="item.codigo" />
          {{ item.nome }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { IDIOMAS, useIdioma, type Idioma } from '../../i18n/idioma'
import Bandeira from './Bandeira.vue'

const { escolhido, definirIdioma } = useIdioma()
const aberto = ref(false)
const raiz = ref<HTMLElement | null>(null)

const rotulo = computed(() => ({ pt: 'Escolher idioma', en: 'Choose language', es: 'Elegir idioma' })[escolhido.value])

const escolher = (idioma: Idioma) => {
  definirIdioma(idioma)
  aberto.value = false
}

const fecharFora = (evento: MouseEvent) => {
  if (raiz.value && !raiz.value.contains(evento.target as Node)) aberto.value = false
}

onMounted(() => document.addEventListener('click', fecharFora))
onUnmounted(() => document.removeEventListener('click', fecharFora))
</script>

<style scoped>
.idioma { position: relative; }

.idioma-botao {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 38px;
  padding: 0 10px;
  border-radius: 10px;
  border: 1px solid var(--a2-line-strong);
  color: var(--a2-ink);
  background: transparent;
  font-family: var(--a2-mono);
  font-size: 12px;
}

.idioma-botao:hover { background: var(--a2-card); border-color: var(--a2-primary-soft); }
.idioma-botao:focus-visible, .idioma-opcao:focus-visible { outline: 2px solid var(--a2-primary-soft); outline-offset: 2px; }

.idioma-lista {
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  min-width: 160px;
  padding: 6px;
  border-radius: 12px;
  border: 1px solid var(--a2-line-strong);
  background: var(--a2-card-solid);
  box-shadow: 0 20px 50px -20px rgba(0, 0, 0, 0.45);
  z-index: 60;
}

.idioma-opcao {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 10px;
  border-radius: 8px;
  font-size: 14px;
  color: var(--a2-ink);
  background: transparent;
  text-align: left;
}

.idioma-opcao:hover { background: var(--a2-card); }
.idioma-opcao.ativo { color: var(--a2-signal); font-weight: 600; }

@media (max-width: 400px) {
  .idioma-sigla { display: none; }
}
</style>
